import { ComputedRef } from 'vue'

import { TestCase } from '@/domain/value_objects/testCase/TestCase'
import { JudgeCaseViewModel } from '@/presentation/viewmodels/testCase/judgeCaseViewModel'

export class JudgeCasePresenter {
  private viewModel: JudgeCaseViewModel

  constructor(viewModel: JudgeCaseViewModel) {
    this.viewModel = viewModel
  }

  get judgeCaseList(): ComputedRef<TestCase[]> {
    return this.viewModel.judgeCaseList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getJudgeCaseList(problemId: string): Promise<void> {
    await this.viewModel.getJudgeCaseList(problemId)
  }
}
